interface Props {
	backendUri?: string;
	pictureId?: string;
	userId?: string;
	cacheKey?: string;
}

export const getProfileImageByUserId = ({
	backendUri,
	pictureId,
	userId,
	cacheKey
}: Props): string => {
	if (!backendUri || !userId) {
		return "";
	}

	const normalizedBackendUri = backendUri.replace(/\/+$/, "");
	const baseUrl = `${normalizedBackendUri}/rest/user/picture/v2/${encodeURIComponent(
		userId
	)}`;

	const searchParams = new URLSearchParams();

	if (pictureId) {
		searchParams.set("pictureId", pictureId);
	}

	if (cacheKey) {
		searchParams.set("v", cacheKey);
	}

	if (!searchParams.toString()) {
		return baseUrl;
	}

	return `${baseUrl}?${searchParams.toString()}`;
};
